import { useTranslate } from 'hooks/useTranslate';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import RecipientsTable from './RecipientsTable';

const CommunicationRecipientsSection = () => {
  const { t } = useTranslate();

  const { actions } = useCommunicationDetailsPage();

  return (
    <div className="table-recipients m-0">
      <div className="d-flex flex-row justify-content-between">
        <h6 className="m-0">{t('DeliveryStatus')}</h6>

        <span
          className="attach-download link"
          onClick={actions.handleOpenCertification}
        >
          <em className="icon ni ni-external text-primary cursor-pointer" />
          <span className="cursor-pointer mr-2">{t('ViewCertificate')}</span>
        </span>
      </div>

      <div
        className="card card-bordered mt-3"
        style={{ overflowX: 'auto', maxWidth: '100%' }}
      >
        <RecipientsTable isResumeTable />
      </div>
    </div>
  );
};

export default CommunicationRecipientsSection;
